/*
	PVRModel
*/
import React from 'react'
import {PVRMatrix4x4, PVRVector4, PVRQuaternion, PVRVector3} from "./PVRMaths"
import {EPODErrorCodes} from "./PVRPODLoader"

export const EPVRModel =
{
	Light:
	{
		ePoint       : 0,
		eDirectional : 1,
		eSpot        : 2,
	},

	Material:
	{
		BlendFunction:
		{
			eZERO                   : 0,
			eONE                    : 1,
			eBLEND_FACTOR           : 2,
			eONE_MINUS_BLEND_FACTOR : 3,

			eSRC_COLOR              : 0x0300,
			eONE_MINUS_SRC_COLOR    : 0x0301,
			eSRC_ALPHA              : 0x0302,
			eONE_MINUS_SRC_ALPHA    : 0x0303,
			eDST_ALPHA              : 0x0304,
			eONE_MINUS_DST_ALPHA    : 0x0305,
			eDST_COLOR              : 0x0306,
			eONE_MINUS_DST_COLOR    : 0x0307,
			eSRC_ALPHA_SATURATE     : 0x0308,

			eCONSTANT_COLOR           : 0x8001,
			eONE_MINUS_CONSTANT_COLOR : 0x8002,
			eCONSTANT_ALPHA           : 0x8003,
			eONE_MINUS_CONSTANT_ALPHA : 0x8004,
		},

		BlendOperation:
		{
			eADD              : 0x8006,
			eMIN              : 0x8007,
			eMAX              : 0x8008,
			eSUBTRACT         : 0x800A,
			eREVERSE_SUBTRACT : 0x800B,
		}
	}
}

export class PVRModel  extends React.Component{

    render(){
        return null
    }



 data =
	{
		clearColour: null,
		ambientColour: null,

		numCameras: 0,
		cameras: [],

		numLights: 0,
		lights: [],

		numMeshes: 0,
		meshes: [],

		numNodes: 0,
		numMeshNodes: 0,
		nodes: [],

		numTextures: 0,
		textures: [],

		numMaterials: 0,
		materials: [],

		numFrames: 0,
		currentFrame: 0,
		fps: 0,

		userData: null,

		units: 0.0,
		flags: 0,

        cache: {}
	
}
	// Public methods
	InitCache  ()
	{
        this.data.cache.worldMatrixFrameZero = [];
        this.data.cache.cachedFrame = [];
        this.data.cache.worldMatrixFrameN = [];
        this.data.cache.frame = 0;
        this.data.cache.frameFraction = 0.0;

        this.FlushCache();

		return EPODErrorCodes.eNoError;
	}

    FlushCache  ()
    {
        this.setCurrentFrame(0);

        for(let  i = 0; i < this.data.numNodes; ++i)
        {
            let  m = this.getWorldMatrixNoCache(i);
            this.data.cache.worldMatrixFrameZero[i] = m;

            // Set out caches to frame 0
            this.data.cache.worldMatrixFrameN[i] = m;
            this.data.cache.cachedFrame[i] = 0.0;
        }
    }

	Material()
	{
		this.data =
		{
			name: "",
			diffuseTextureIndex        : -1,
			ambientTextureIndex        : -1,
			specularTextureIndex       : -1,
			specularLevelTextureIndex  : -1,
			bumpMapTextureIndex        : -1,
			emissiveTextureIndex       : -1,
			glossinessTextureIndex     : -1,
			opacityTextureIndex        : -1,
			reflectionTextureIndex     : -1,
			refractionTextureIndex     : -1,
			opacity    : 1,
			ambient    : null,
			diffuse    : null,
			specular   : null,
			shininess  : 0,
			effectFile : "",
			effectName : "",

			blendSrcRGB : EPVRModel.Material.BlendFunction.eONE,
			blendSrcA   : EPVRModel.Material.BlendFunction.eONE,
			blendDstRGB : EPVRModel.Material.BlendFunction.eZERO,
			blendDstA   : EPVRModel.Material.BlendFunction.eZERO,
			blendOpRGB  : EPVRModel.Material.BlendOperation.eADD,
			blendOpA    : EPVRModel.Material.BlendOperation.eADD,

			flags    : 0,
			userData : null,
		}
	}

	Texture ()
	{
		this.data =
		{
			name: ""
		}
	}

	Light ()
	{
		this.data =
		{
			targetIndex: -1,
			colour: null,
			type: EPVRModel.Light.ePoint,
			constantAttenuation: 1.0,
			linearAttenuation: 0.0,
			quadraticAttenuation: 0.0,
			falloffAngle: Math.pi,
			falloffExponent: 0.0,
		}
	}

	Camera  ()
	{
		this.data =
		{
			targetIndex: 0,
			far: 0.0,
			near: 0.0,
			numFrames: 0,
			FOVs: null,
		}

		this.getFOV = function (frame, interp)
		{
			if(this.data.FOVs)
			{
				if(this.data.numFrames > 1)
				{
					if(frame >= this.data.numFrames-1)
						throw new RangeError();

					let  fov0 = this.data.FOVs[frame+0];
					let  fov1 = this.data.FOVs[frame+1];
					return fov0 + interp * (fov1 - fov0);
				}
				else
				{
					return this.data.FOVs[0];
				}
			}
			else
			{
				return 0.7;
			}
		}
	}

	Node  ()
	{
		this.data =
		{
			index: -1,
			name: "",
			materialIndex: -1,

			parentIndex: -1,

			animation: null,

			userData: null,
		}
	}

     setCurrentFrame (frame)
	{
		if(this.data.numFrames > 0)
		{
			/*
				Limit animation frames.

				Example: If there are 100 frames of animation, the highest frame
				number allowed is 98, since that will blend between frames 98 and
				99. (99 being of course the 100th frame.)
			*/


			if(frame > (this.data.numFrames - 1)){
				throw new RangeError();}

			this.data.cache.frame = Math.floor(frame);
			this.data.cache.frameFraction = frame - this.data.cache.frame;
		}
		else
		{
			if(Math.floor(frame) !== 0){
				console.log ("frame !==0",frame);
				throw new RangeError();}

			this.data.cache.frame = 0;
			this.data.cache.frameFraction = 0;
		}

        this.data.currentFrame = frame;
	}

	getCameraFrom(id, frame, offset){
		return this.data.nodes[id].data.animation.getTranslationVector(frame,offset);
	}


	getCameraExtension(id, frame, offset){
	
		let  props = {};
		let m = this.data.nodes[id].data.animation.getFrameRotationMatrix(frame);
		props.from = this.data.nodes[id].data.animation.getTranslationVector(frame,offset);
        props.direction =  new PVRVector3(-m.data[4],  -m.data[5],-m.data[6]);
		props.up   = new PVRVector3(-m.data[8],  -m.data[9],-m.data[10]);
		props.to   = new PVRVector3.add(  props.from,   props.direction);
		props.right = new PVRVector3.cross( props.up,  props.direction);

	// 	this.m_vCameraDirection = new PVRVector3(-rotMatrix[1][0], -rotMatrix[1][1], -rotMatrix[1][2]);
	// this.m_vCameraUp =     new PVRVector3(-rotMatrix[2][0], -rotMatrix[2][1], -rotMatrix[2][2]);
	// this.m_vCameraTo =    new  PVRVector3.add(  this.m_vCameraFrom ,  this.m_vCameraDirection);
    // this.m_vCameraRight =   new PVRVector3.cross( this.m_vCameraUp,  this.m_vCameraDirection);

		
		return props;
	}


    getWorldMatrix(id)
    {
        // There is a dedicated cache for frame 0
        if(this.data.currentFrame === 0)
        {
            return this.data.cache.worldMatrixFrameZero[id];
        }

        // Has this matrix been calculated and cached?
        if(this.data.currentFrame === this.data.cache.cachedFrame[id])
        {
            return this.data.cache.worldMatrixFrameN[id];
        }

        // Calculate the matrix and cache it
        let  node = this.data.nodes[id];
        let  m = this.data.cache.worldMatrixFrameN[id] = node.data.animation.getTransformationMatrix(this.data.cache.frame,
                                                                                                    this.data.cache.frameFraction);
        let  parentID = node.data.parentIndex;
        if(parentID < 0)
        {
            this.data.cache.worldMatrixFrameN[id] = m;
        }
        else
        {
            this.data.cache.worldMatrixFrameN[id] = PVRMatrix4x4.matrixMultiply(this.getWorldMatrix(parentID), m);
        }

        this.data.cache.cachedFrame[id] = this.data.currentFrame;
        return this.data.cache.worldMatrixFrameN[id];
    }

	

	getWorldMatrixNoCache(id)
	{
		let  m        = this.data.nodes[id].data.animation.getTransformationMatrix(this.data.cache.frame,
																				  this.data.cache.frameFraction);
		let  parentID = this.data.nodes[id].data.parentIndex;

		if(parentID < 0)
			return m;

		return PVRMatrix4x4.matrixMultiply(this.getWorldMatrixNoCache(parentID), m);
	}

	getCameraProperties (cameraIdx)
	{
		if(cameraIdx < 0 || cameraIdx >= this.data.numCameras){
		
			throw new RangeError();
		}
		let  m     = this.getWorldMatrix(this.data.numMeshNodes + this.data.numLights + cameraIdx);
		let  props = {};

		props.from = new PVRVector3();
		props.up   = new PVRVector3();
		props.to   = new PVRVector3();

		// View position is 0,0,0,1 transformed by world matrix
		props.from.data[0] = m.data[12];
		props.from.data[1] = m.data[13];
		props.from.data[2] = m.data[14];

		// When you rotate the camera from "straight forward" to "straight down", in OpenGL the UP vector will be [0, 0, -1]
		props.up.data[0] = -m.data[8];
		props.up.data[1] = -m.data[9];
		props.up.data[2] = -m.data[10];

		let  camera = this.data.cameras[cameraIdx];
        
		// TODO: Experimental!
		if(camera.data.targetIndex !== -1)
		{
			
			let  atCurrent, atTarget;
			atCurrent = PVRVector3.subtract(props.to, props.from);
			atCurrent.normalise();

	
			let  targetMatrix = this.getWorldMatrix(camera.data.targetIndex);

			props.to.data[0] = targetMatrix.data[12];
			props.to.data[1] = targetMatrix.data[13];
			props.to.data[2] = targetMatrix.data[14];

			// Rotate our up vector
			atTarget = PVRVector3.subtract(props.to, props.from);
			atTarget.normalise();


			let  axis  = PVRVector3.cross(atCurrent, atTarget);
			let  angle = PVRVector3.dot(atCurrent, atTarget);

			let  q    = PVRQuaternion.createFromAxisAndAngle(axis, angle);

			let currentUp = new PVRVector4(props.up.data[0],props.up.data[1],props.up.data[2],  0)
			props.up = ( PVRMatrix4x4.multiply( q.toRotationMatrix(),currentUp ));
			props.up = new PVRVector3(props.up.data[0], props.up.data[1],props.up.data[2]);
			props.up.normalise();
			
		}
		else
		{
			// View direction is 0,-1,0,1 transformed by world matrix
			props.to.data[0] = -m.data[4] + props.from.data[0];
			props.to.data[1] = -m.data[5] + props.from.data[1];
			props.to.data[2] = -m.data[6] + props.from.data[2];
		}



		props.fov = camera.getFOV(this.data.cache.frame, this.data.cache.frameFraction);
		return props;
	}


	getLightPosition(lightIdx){

		if(lightIdx < 0 || lightIdx >= this.data.numLights)
		throw new RangeError();
		let m =   this.getWorldMatrix(this.data.numMeshNodes + lightIdx);
		return new PVRVector4( m.data[12], m.data[13] ,m.data[14], 0.0); 
			
	}


	getLightDirection (lightIdx)
	{
		if(lightIdx < 0 || lightIdx >= this.data.numLights)
			throw new RangeError();

		let  m = this.getWorldMatrix(this.data.numMeshNodes + lightIdx);
		let  targetIndex = this.data.lights[lightIdx].data.targetIndex;

		let  directionVector = new PVRVector4();
		directionVector.data[3] = 0.0;
		if(targetIndex !== -1)
		{
			let  targetMatrix = this.getWorldMatrix(targetIndex);
			directionVector.data[0] = targetMatrix.data[12] - m.data[12];
			directionVector.data[1] = targetMatrix.data[13] - m.data[13];
			directionVector.data[2] = targetMatrix.data[14] - m.data[14];
			directionVector.normalise();
		}
		else
		{
			directionVector.data[0] = -m.data[4];
			directionVector.data[1] = -m.data[5];
			directionVector.data[2] = -m.data[6];
		}

		return directionVector;
	}
}

export default PVRModel